import {
  Button,
  DialogClose,
  InterceptDialog,
  TextField,
  Typography,
} from "@hellocarbo/lasagne";
import { use } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { PortalContainerContext, UserContext } from "@/contexts";
import useSegmentEvent from "@/hooks/useSegmentEvent";

type ExternalProviderProps = {
  defaultExternalProvider: string;
  onNextButtonClick: () => void;
};

function ExternalProvider({
  defaultExternalProvider,
  onNextButtonClick,
}: ExternalProviderProps) {
  const { t } = useTranslation(["common", "externalCampaign"]);
  const { user } = use(UserContext);
  const { container } = use(PortalContainerContext);
  const { sendSegmentEvent } = useSegmentEvent();

  const canCreateExternalCampaign =
    user?.policies?.external_score.queries["create"];

  return (
    <div>
      <Typography className="mb-lg">
        {t("externalCampaign:externalProvider.description")}
      </Typography>
      <TextField
        name="externalProvider"
        label={t("externalCampaign:externalProvider.label")}
        defaultValue={defaultExternalProvider}
        placeholder={t("externalCampaign:externalProvider.placeholder")}
        fullWidth
      />

      <div className="mt-lg text-center">
        <InterceptDialog
          show={!canCreateExternalCampaign}
          title={t("externalCampaign:upsellModal.title")}
          description={t("externalCampaign:upsellModal.description")}
          warningMessage={t("externalCampaign:upsellModal.warningMessage")}
          footer={
            <DialogClose asChild>
              <Button
                as={Link}
                to="/options/subscription?option=external_score"
                onClick={() =>
                  sendSegmentEvent("option_subscription", {
                    size: `${user?.company.employees}`,
                  })
                }
              >
                {t("common:requestSubscription")}
              </Button>
            </DialogClose>
          }
          portalContainer={container as Element}
        >
          <Button onClick={onNextButtonClick}>{t("common:next")}</Button>
        </InterceptDialog>
      </div>
    </div>
  );
}

export default ExternalProvider;
